import { render } from "./JroProjectsNew.vue?vue&type=template&id=a9c17786&scoped=true&ts=true"
import script from "./JroProjectsNew.vue?vue&type=script&lang=ts"
export * from "./JroProjectsNew.vue?vue&type=script&lang=ts"

import "./JroProjectsNew.vue?vue&type=style&index=0&id=a9c17786&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@5.1.6__webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9c17786"]])

export default __exports__